// extracted by mini-css-extract-plugin
export default {"box":"resource-dialog_box__OPwkG","overrideIcon":"resource-dialog_overrideIcon__aV72T"};